import React from 'react'

import Container from 'react-bootstrap/Container'
import NetworkMap, { NO_SELECTION_MODE } from './map'
import {
    setNetwork,
} from './network'
import { RingSpinnerOverlay } from 'react-spinner-overlay';
import { DefaultColorScheme } from './color';


class NetworkViewer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            "viewport": {
                "latitude": this.props.initialLat,
                "longitude": this.props.initialLon,
                "zoom": 11,
            },
            "stops": {},
            "linestrings": {},
            "routesForRoutings": {}
        };

        this.loadNetworkPromise = (networkId) => setNetwork(this, networkId);

        this.setViewport = (viewport) => {
            this.setState({ "viewport": viewport });
        }

        this.setSector = (sectorId) => { };

        this.setExpandedSector = (sectorId) => { }

        this.clearExpandedSector = () => { };

        this.setTransformationType = (type) => { };

        this.setDuration = (duration) => { }

        this.setBaselineDuration = (duration) => { }

        this.colorScheme = new DefaultColorScheme()


    }

    componentDidMount() {
        this.loadNetworkPromise(this.props.networkId);
    }



    render() {
        return (
            <>
                <RingSpinnerOverlay
                    loading={Object.keys(this.state.routesForRoutings).length === 0}
                    color="#000000" />
                <Container fluid style={{
                    "display": "flex",
                    "flexDirection": "column",
                    "flexGrow": 1
                }}>
                    <NetworkMap
                        stops={this.state.stops}
                        linestrings={this.state.linestrings}
                        routesForRoutings={this.state.routesForRoutings}
                        gridId={undefined}
                        colorScheme={this.colorScheme}
                        sectorTransformations={[]}
                        expandedSectorTransformations
                        ={[]}
                        transformationType={undefined}
                        calculationCenterPoints
                        ={[]}
                        baselineCenterPoints
                        ={[]}
                        calculationCenterSectors
                        ={[]}
                        baselineCenterSectors
                        ={[]}
                        setSector={this.setSector}
                        selectedSector={this.state.selectedSector}
                        expandedSector={this.state.expandedSector}
                        loadingExpansion={false}
                        setExpandedSector={this.setExpandedSector}
                        clearExpandedSector={this.clearExpandedSector}
                        unGridIt={this.props.unGridIt}
                        showSelect={false}
                        selectionMode={NO_SELECTION_MODE}
                        viewport={this.state.viewport}
                        setViewport={this.setViewport}
                        isComparison={false}
                        isExhaustive={false}
                        setTransformationType={this.setTransformationType}
                        boundaryFindingMode={false}
                        minRouteZoom={0}
                        excludeRoutes={this.props.excludeList} />
                </Container>
            </>);
    }
}

export default NetworkViewer;